import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {Technology}  from '../../types/types';

import { getCategoryLabelById, getThemeByCategoryId } from '../../lib/themeHelper';

import { Parser } from "html-to-react";

import "../../css/overlay.css";

interface OverlayProps {
    tag: Technology;
    onClose: () => void;
}

const Overlay: FC<OverlayProps> = ({ tag, onClose}) => {
    const { t } = useTranslation();

    // @ts-ignore
    const htmlParser = new Parser();

    return (
        <div className="overlay">
            <div className="overlay-content">
                <div className={'close-cont'}>
                    <button className="close-button" onClick={() => onClose()}>
                        <div className={"close"}></div>
                    </button>
                </div>

                <h3 className="category-title">
                    <div className={`${getThemeByCategoryId(tag.categories!)}-icon`}>
                    </div>{ typeof tag.categories === 'number' ? getCategoryLabelById(tag.categories) : '' }
                </h3>

                <h1 className="title">{tag.title}</h1>

                <p className="importance">{t('Bedeutung')}: <span className={'rating'}>{tag.economic_importance}/10</span></p>
                <p className="competence">{t('Kompetenz')}: <span className={'rating'}>{tag.competence}/10</span></p>

                <p className="description">{htmlParser.parse(tag.description)}</p>

                <a href={t('detailLink').concat(tag.slug ? tag.slug : '')}><button className="more-button" onClick={() => onClose()}>
                    {t('Mehr')}
                </button></a>
            </div>
        </div>
    );
};

export default Overlay;